import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { PublicLayout } from "@/components/PublicLayout";
import { useI18n } from "@/i18n/I18nContext";
import api from "@/lib/api";
import { Seo } from "@/components/Seo";

const TEAM_CRUMBS = [{ name: "Equipo", path: "/team" }];

export default function Team() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [coaches, setCoaches] = useState([]);
  useEffect(() => { api.get("/coaches").then(({ data }) => setCoaches(data)); }, []);
  const teamLd = useMemo(() => coaches.length ? {
    "@type": "SportsActivityLocation", name: "Frenchies Fitness & Pilates", url: "https://frenchiesfitness.com/team",
    employee: coaches.map((c) => ({ "@type": "Person", name: c.name, jobTitle: c.title?.es || c.specialty || "Coach", image: c.photo_url || undefined, worksFor: { "@type": "Organization", name: "Frenchies Fitness & Pilates" } })),
  } : null, [coaches]);

  return (
    <PublicLayout>
      <Seo
        title="Coaches del gym Frenchies Fitness & Pilates en Coronado — Equipo"
        description="Conoce a los coaches certificados y trilingües de Frenchies Fitness & Pilates en Coronado, Panamá: functional movement, Pilates Reformer y coaching privado."
        path="/team"
        keywords="coaches Coronado, entrenador personal Coronado, coach instructor Pilates Coronado, gym Coronado equipo"
        jsonLd={teamLd}
        breadcrumbs={TEAM_CRUMBS}
      />
      <section className="mx-auto max-w-7xl px-5 py-12 lg:px-8">
        <h1 className="mb-3 font-display text-4xl font-bold tracking-tight sm:text-5xl">{t("nav.team")}</h1>
        <p className="mb-10 max-w-xl text-muted-foreground">Frenchies Fitness · Private Coaches</p>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {coaches.map((c, i) => (
            <motion.button
              key={c.coach_id}
              data-testid={`coach-card-${c.coach_id}`}
              onClick={() => navigate("/schedule")}
              whileHover={{ y: -4 }}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="group overflow-hidden rounded-2xl border border-border bg-[#141b2e] text-left shadow-sm"
            >
              <img src={c.photo} alt={c.name} className="w-full transition-transform duration-500 group-hover:scale-[1.02]" />
            </motion.button>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
